import React, { useRef, useEffect } from 'react'
import panzoom from 'panzoom'
import { useNavigate } from 'react-router-dom'
import { useConfig, useModal } from '@/hooks'

import style from '../styles/mobile.module.scss'
import {
  homeMobileBack
} from '@/images'
import AsyncComponent from '@/components/AsyncComponent'

const AsyncTopMobile = AsyncComponent(async () => await import('./TopMobile'))

const Mobile = (): React.ReactElement => {
  const nodeMove = useRef(null)
  const navigate = useNavigate()
  const config = useConfig()
  const { openModal } = useModal()

  const redirectToPage = ({ url }: { url: string }): void => navigate(url)

  const {
    games = '/',
    education = '/',
    tournaments = '/',
    news = '/',
    leaders_contacts: leadersContacts = ''
  } = config

  const showFamilyModal = (): void => {
    openModal('family')
  }

  useEffect(() => {
    const n = document.getElementById('Frame 982_3')
    if (n != null) {
      n.addEventListener('click', () => {
        console.log('chgeck!!!')
      })
    }
  }, [])

  const redirect = {
    CONTACTS: () => redirectToPage({ url: leadersContacts }),
    EDUCATION: () => redirectToPage({ url: education }),
    FAMILY: () => showFamilyModal(),
    GAMES: () => redirectToPage({ url: games }),
    NEWS: () => redirectToPage({ url: news }),
    TOURNEY: () => redirectToPage({ url: tournaments })
    // INIT_SCENE: () => endLoadingScene()
  }

  useEffect(() => {
    const node = nodeMove.current
    if (node !== null) {
      panzoom(node, {
        maxZoom: 1.2,
        minZoom: 0.35,
        bounds: true,
        boundsPadding: 1,
        initialX: -300,
        initialY: -300,
        initialZoom: 0.4,
        onDoubleClick: function (e) {
          // `e` - is current double click event.

          return false // tells the library to not preventDefault, and not stop propagation
        },
        onClick: (e) => {
          const target = e.target as HTMLElement
          const el = target.closest('[data-url]') as HTMLElement
          if (el !== null) {
            const url = el.dataset.url
            if (url !== undefined && redirect[url] !== undefined) {
              redirect[url]()
            }
          }
        }
      })
    }
  }, [])
  return (
    <div className={style.main}>
      <div ref={nodeMove} className={style.wraper}>
        <img className={style.back} src={homeMobileBack} />
        <AsyncTopMobile />
      </div>
    </div>
  )
}

export {
  Mobile
}
